// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"eb420ddb","626":"dcb16c87"}[chunkId] + ".chunk.js";
};